<!--
  ~ Copyright (c) Akveo 2019. All Rights Reserved.
  ~ Licensed under the Single Application / Multi Application License.
  ~ See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
  -->
<img src="assets/images/logo.png" class="img-fluid" alt="{{ altText }}" />
<h1 id="title" class="title">Verify</h1>
<p class="sub-title">Please set your password</p>

<nb-alert
  *ngIf="showMessages?.error && errors?.length && !submitted"
  outline="danger"
  role="alert"
>
  <p class="alert-title"><b>Oh snap!</b></p>
  <ul class="alert-message-list">
    <li *ngFor="let error of errors" class="alert-message">{{ error }}</li>
  </ul>
</nb-alert>

<nb-alert
  *ngIf="showMessages?.success && messages?.length && !submitted"
  outline="success"
  role="alert"
>
  <p class="alert-title"><b>Hooray!</b></p>
  <ul class="alert-message-list">
    <li *ngFor="let message of messages" class="alert-message">
      {{ message }}
    </li>
  </ul>
</nb-alert>

<div [formGroup]="verifyForm" aria-labelledby="title">
  <div class="form-control-group">
    <label for="input-password">Password:</label>
    <input
      nbInput
      autofocus
      fullWidth
      formControlName="password"
      type="password"
      [status]="displayFieldCss(verifyForm, f.password)"
      class="first"
      placeholder="Password"
    />
    <app-form-field-error
      [displayError]="f.password.dirty && f.password.errors?.required"
      [displaySuccess]="f.password.valid"
      errorMsg="New password is required"
    ></app-form-field-error>

    <app-form-field-error
      [displayError]="f.password.dirty && f.password.errors?.passwordInvalid"
      [displaySuccess]="false"
      [errorMsg]="getPasswordErrorMessage()"
    ></app-form-field-error>
    <app-form-field-error
      [displayError]="
        f.password.dirty && f.password.errors?.passwordValidationError
      "
      [displaySuccess]="false"
      errorMsg="Error validating password"
    ></app-form-field-error>
    <app-form-field-error
      [displayError]="
        f.password.dirty && f.password.valid && !f.password.pending
      "
      [displaySuccess]="true"
      errorMsg=""
    ></app-form-field-error>
  </div>

  <div class="form-control-group">
    <label for="input-re-password">Confirm Password:</label>
    <input
      nbInput
      fullWidth
      id="input-re-password"
      formControlName="confirmPassword"
      type="password"
      [status]="displayFieldCss(verifyForm, f.confirmPassword)"
      placeholder="Password"
    />
    <app-form-field-error
      [displayError]="
        f.confirmPassword.errors?.mustMatch &&
        !f.confirmPassword.errors?.required
      "
      [displaySuccess]="f.confirmPassword.valid"
      errorMsg="Passwords do not match!"
    ></app-form-field-error>
  </div>

  <div class="form-control-group">
    <label for="passwordRequirements">Password Requirements</label>
    <textarea
      id="passwordRequirements"
      style="font-size: smaller"
      class="form-control"
      rows="7"
      [value]="passwordRequirements"
      readonly
    ></textarea>
  </div>

  <button
    nbButton
    status="success"
    fullWidth
    [disabled]="submitted || verifyForm.invalid || verifyForm.pending"
    [class.btn-pulse]="submitted"
    (click)="verify()"
  >
    Set password
  </button>
</div>

<section class="another-action" aria-label="Sign in">
  Already have an account? <a class="text-link" routerLink="../login">Log in</a>
</section>
